import React, { useEffect, useRef, useState } from 'react';

const AnimatedSection = ({ children, className = '', delay = 0, animation = 'fadeInUp' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [delay]);

  const getAnimationClass = () => {
    if (!isVisible) return 'opacity-0';
    
    switch (animation) {
      case 'fadeInUp':
        return 'opacity-100 translate-y-0';
      case 'fadeInLeft':
        return 'opacity-100 translate-x-0';
      case 'fadeInRight':
        return 'opacity-100 -translate-x-0';
      case 'scaleIn':
        return 'opacity-100 scale-100';
      case 'rotateIn':
        return 'opacity-100 rotate-0';
      default:
        return 'opacity-100';
    }
  };

  const getInitialClass = () => {
    switch (animation) {
      case 'fadeInUp':
        return 'translate-y-8';
      case 'fadeInLeft':
        return '-translate-x-8';
      case 'fadeInRight':
        return 'translate-x-8';
      case 'scaleIn':
        return 'scale-95';
      case 'rotateIn':
        return 'rotate-3';
      default:
        return '';
    }
  };

  return (
    <div
      ref={elementRef}
      className={`transition-all duration-700 ease-out ${getInitialClass()} ${getAnimationClass()} ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;